import { Button, Table, Spinner, Row, Col } from "react-bootstrap";
import { TemplatePagination } from "../types";
import { useState } from 'react';
import { useTranslation } from "react-i18next";
import { deleteTemplate, cloneTemplate } from "../api/templateAPI";
import { useNavigate } from 'react-router-dom';
import ModalGlobal from '../../../../components/AppModal/ModalGlobal';
import { convertUnixMilisegToFormateDate } from '../../../../utils/dateUtils'; 
import AppTablePagination from "../../../../components/AppTable/AppTablePagination";
import { ApiErrorResponse } from "../../../../types/ApiErrorResponse";

interface TemplateTableProps {
    templatesData: TemplatePagination;
    totalPages: number;
    currentPage: number;
    pageSize: number;
    setMessage: (value: string) => void;
}

export default function TemplatesTable({ templatesData, totalPages, currentPage, pageSize, setMessage }: TemplateTableProps) {

    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const [templateId, setTemplateId] = useState(0);


    const [showModal, setShowModal] = useState(false);
    const handleOpen = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    //headers
    const TEMPLATE_TABLE_HEADERS = {
        id: t("template:headerTableTemplate1"),
        clientName: t("template:headerTableTemplate2"),
        cif: t("template:headerTableTemplate3"),
        dateRegistered: t("template:headerTableTemplate4"),
        actions: t("common:actions")
    };

    const handleExportCsv = () => {
        console.log("TO DO");
    }
    
    const handleDeleteTemplate = async () => {
        try {
            setLoading(true);

            await deleteTemplate(templateId );
            const updateList = templatesData.items.filter(item => item.idTemplate !== templateId);
            templatesData.items = updateList;
            setLoading(false);
            handleClose();
            setMessage(t("template:modal.messageDeleteTemplateSuccessfully"))
        } catch (error) {
            setLoading(false);
            const fetchError = error as ApiErrorResponse;
            setError(fetchError.message);
        }
    }

    const handleCloneTemplate = async (idTemplate: number) => {
        setLoading(true);
        try {
            const response = await cloneTemplate(idTemplate);
            navigate(`/admin/template/new-template`, { state: { clone: true, template: response } });
        } catch (error) {
            const fetchError = error as ApiErrorResponse;
            setError(fetchError?.message || 'Error to clone template');
        } finally {
            setLoading(false);
        }
    };



    return (

        <div>
            {loading && (
                <div className="overlay-spinner">
                    <Spinner animation="border" variant="light" />
                </div>
            )}
            <ModalGlobal
                show={showModal}
                onClose={handleClose}
                title={t("template:modal.modalDeleteTemplateTitle")}
                subtitle={t("template:modal.modalDeleteTemplateSubtitle")}
                body=""
                onSave={() => {
                    handleDeleteTemplate();
                } }
                saveText={t("common:modalActionOK")}
                closeText={t("common:modalActionNOTOK")}
                isLoading={false}
                contentType='info'
            />

            <Row>
                <Col xs={12} md={12} >
                    {error && (
                        <div className="alert alert-danger">
                            {error}
                            <button
                                type="button"
                                className="btn-close btn-sm position-absolute top-0 end-0 m-2"
                                aria-label="Close"
                                onClick={() => setError('')}
                            ></button>
                        </div>
                    )}
                </Col>
            </Row>
            <Table responsive className="mt-3 text-center">
                <thead>
                    <tr>
                        {Object.values(TEMPLATE_TABLE_HEADERS).map((header, index) => (
                            <th key={Object.keys(TEMPLATE_TABLE_HEADERS)[index]} className="text-center" style={{ borderTop: "none", borderBottom: "1px solid black" }}>
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>

                {templatesData && templatesData.items.length > 0 ? (
                    <tbody>
                        {templatesData.items.map((data, index) => (
                            <tr key={index}>
                                <td className="text-center" style={{ verticalAlign: "middle" }}>
                                    <div>
                                        {data.idTemplate}
                                    </div>
                                </td>                           
                                <td className="text-start" style={{ verticalAlign: "middle" }}>
                                    <div>
                                        {data.description}
                                    </div>
                                </td>
                                <td className="text-center" style={{ verticalAlign: "middle" }}>
                                    <div>
                                        {convertUnixMilisegToFormateDate(data.effectiveStartDate.toString())}
                                    </div>
                                </td>
                                <td className="text-center" style={{ verticalAlign: "middle" }}>
                                    <div>
                                        {data.effectiveEndDate !== null ? convertUnixMilisegToFormateDate(data.effectiveEndDate.toString()) : ""}
                                    </div>
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                    <Button onClick={() => {
                                        setTemplateId(data.idTemplate);
                                        handleOpen(); 
                                    }} className="btn btn-sm btn-gris2" style={{ marginRight: 8, }}>
                                        <i className="bi bi-x" title={t("common:buttons.buttonDelete")}></i>
                                    </Button>
                                    <Button onClick={() => {
                                        handleCloneTemplate(data.idTemplate);
                                    }} className="btn btn-sm btn-gris2" style={{ marginRight: 8, }}>
                                        <i className="bi bi-copy" title={t("common:buttons.buttonCopy")}></i>
                                    </Button>
                                    <Button onClick={() => {
                                        navigate(`/admin/template/${data.idTemplate}`)
                                    }} className="btn btn-sm btn-gris2" style={{ marginRight: 8, }}>
                                        <i className="bi bi-pen" title={t("common:buttons.buttonEdit")}></i>
                                    </Button>
                                </td>
                            </tr>
                        ))}
                        
                    </tbody>
                ) : (

              
                <tbody>
                    <tr>
                    <td className="text-start" colSpan={Object.values(TEMPLATE_TABLE_HEADERS).length}>{t("template:nonregistersTemplates")}</td>
                    </tr>
                </tbody>
                )}

                <tfoot>
                    <AppTablePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        pageSize={pageSize}
                        totalRecords={templatesData.totalRecords}
                        // colSpan={Object.values(TEMPLATE_TABLE_HEADERS).length}
                        showExportLink={true}
                        onExportCsv={handleExportCsv}
                        selectorType="templates"
                    />
                </tfoot>
            </Table>
            
        </div>
)}


